import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './BoxInput.css';
import NormalInput from './NormalInput';

class BoxInput extends Component {
  render() {
    const { className, style, inputClassName, inputStyle } = this.props;
    const classSet = classnames('boxinput-container', className);
    const inputClassSet = classnames('theme--border-accent-focus', inputClassName);
    return (
      <div style={style} className={classSet}>
        <NormalInput {...this.props} className={inputClassSet} style={inputStyle} />
      </div>
    );
  }
}

BoxInput.propTypes = {
  ...NormalInput.propTypes,
  className: PropTypes.string,
  style: PropTypes.object,
  inputClassName: PropTypes.string,
  inputStyle: PropTypes.object
};

BoxInput.defaultProps = {
  ...NormalInput.defaultProps,
  className: '',
  style: {},
  inputClassName: '',
  inputStyle: {}
};

export default BoxInput;
